var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/Filters/InclusionFilter/DependencyFilter.tsx";
import * as React from 'react';
import { useStore } from 'effector-react';
import { RadioButton, Button } from '@gmini/ui-kit';
import { goals } from "../../../../metrika";
import * as filter from "./FilterModel";
import { Subtitle, RadioButtonWrapper, SubtitleContainer } from "./DependencyFilter.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var onChange = filter.byInclusion.set.prepend(function (value) {
  return value;
});
export var DependencyFilter = /*#__PURE__*/React.memo(function (_ref) {
  var seoEventHandler = _ref.seoEventHandler;
  var filterByInclusion = useStore(filter.byInclusion$, {
    loc: {
      file: _effectorFileName,
      line: 23,
      column: 30
    },
    name: "DependencyFilter",
    sid: "DependencyFilter /src/classifier-editor/DependencyTree/Filters/InclusionFilter/DependencyFilter.tsx [23, 30]"
  });

  var onChangeFilter = function onChangeFilter(event) {
    switch (event.target.value) {
      case filter.FilterByInclusion.Off:
        goals.filterSelectAll();
        break;

      case filter.FilterByInclusion.NotIncluded:
        goals.filterSelectNotIncluded();
        break;

      case filter.FilterByInclusion.Included:
        goals.filterSelectIncluded();
        break;
    }

    onChange(event.target.value);
    seoEventHandler === null || seoEventHandler === void 0 ? void 0 : seoEventHandler(event.target.value);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(SubtitleContainer, {
      children: [/*#__PURE__*/_jsx(Subtitle, {
        children: "\u041F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: function onClick() {
          goals.filterSelectAll();
          onChange(filter.FilterByInclusion.Off);
        },
        color: "tertiary",
        size: "small",
        "data-test-id": "resetInclusionFilter",
        children: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u0441\u0435"
      })]
    }), /*#__PURE__*/_jsxs(RadioButtonWrapper, {
      children: [/*#__PURE__*/_jsx(RadioButton, {
        onChange: onChangeFilter,
        label: "\u0412\u0441\u0435",
        name: "filterByInclusion",
        checked: filterByInclusion === filter.FilterByInclusion.Off,
        value: filter.FilterByInclusion.Off,
        "data-test-id": "all"
      }), /*#__PURE__*/_jsx(RadioButton, {
        onChange: onChangeFilter,
        label: "\u0423\u0447\u0442\u0435\u043D\u043D\u044B\u0435",
        name: "filterByInclusion",
        "data-test-id": "accounted",
        checked: filterByInclusion === filter.FilterByInclusion.Included,
        value: filter.FilterByInclusion.Included
      }), /*#__PURE__*/_jsx(RadioButton, {
        onChange: onChangeFilter,
        label: "\u041D\u0435 \u0443\u0447\u0442\u0435\u043D\u043D\u044B\u0435",
        name: "filterByInclusion",
        "data-test-id": "unaccounted",
        checked: filterByInclusion === filter.FilterByInclusion.NotIncluded,
        value: filter.FilterByInclusion.NotIncluded
      })]
    })]
  });
});
DependencyFilter.displayName = 'DependencyFilter';